
import React from "react";


const UserContext = React.createContext({
    isSignedIn: false,
    user: null // this user object comes from firebase auth library
  });

export default UserContext